import { render, staticRenderFns } from "./ControlesPYR.vue?vue&type=template&id=61b6178a"
import script from "./ControlesPYR.vue?vue&type=script&lang=js"
export * from "./ControlesPYR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports